import type { WordCollection } from "../collection.types";
import { createCollection } from "../logic";

const gardensWordList = [
  "bed",
  "bee",
  "bloom",
  "branch",
  "bulb",
  "butterfly",
  "dig",
  "evergreen",
  "fragile",
  "garden",
  "grow",
  "leaf",
  "life",
  "moss",
  "path",
  "plant",
  "resilient",
  "ripe",
  "robust",
  "root",
  "shade",
  "soil",
  "stem",
  "thrive",
  "transform",
  "tree",
  "water",
  "yield",
  "zone",
];

export const gardensCollection: WordCollection = createCollection(
  "gardens",
  "Gardens & Growth",
  gardensWordList,
  { icon: "flower-tulip-outline", isWordlistViewable: true }, // Example icon
);
